import React, { Fragment, useEffect, useState } from "react";

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Col,
  Form,
  Label,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import axios from "axios";
import { AlertCircle, CheckCircle, Clock, XCircle } from "react-feather";
import { Controller, useForm } from "react-hook-form";
// ** Third Party Components
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// styles import
import "@styles/react/libs/file-uploader/file-uploader.scss";
import "@styles/react/libs/react-select/_react-select.scss";
import { useMediaQuery } from '@mui/material'


import RubriDoc from "@src/assets/images/logo/RubriDoc.png";
import crediq from "@src/assets/images/logo/crediq.png";
import moment from "moment/moment";
import PDFViewer from "../sign-document/components/pdf-viewer";
import CustomDate from "../../../views/components/date-picker/index";
import DocumentList from "./components/DocumentList";

const InvoicesViewer = () => {
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [expirePage, setExpirePage] = useState(false);
  const [pdfActive, setPdfActive] = useState(0);
  const [checks, setChecks] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState({});
  const [filteredDocuments, setFilteredDocuments] = useState([]);


  const isMobile = useMediaQuery('(max-width:767px)');

  const { control, handleSubmit, reset } = useForm({
    shouldUnregister: true,
  });
  

  const onSubmit = async (data) => {
    const fromDate = moment(data.fromDate, "DD-MM-YYYY");
    const toDate = moment(data.toDate, "DD-MM-YYYY");

    const newFilteredDocuments = mockDocuments.filter((document) => {
      if (document.date) {
        const documentDate = moment(document.date, "DD-MM-YYYY");
        return documentDate.isBetween(fromDate, toDate, null, "[]");
      }
      return false;
    });

    setFilteredDocuments(newFilteredDocuments);
  };

  const handleReset = () => {
    reset(
      {
        fromDate: moment(""),
        toDate: moment(""),
      },
      {
        keepErrors: false,
        keepDirty: false,
        keepIsSubmitted: false,
        keepTouched: false,
        keepIsValid: false,
      }
    );
    setFilteredDocuments([]);
  };

  const mockDocuments = [
    {
        id: 1,
        name: "Documento1",
        documentName: "Documento1.pdf",
        size: "2MB",
        status: 200,
        date: "28-12-2024",
      },
      {
        id: 2,
        name: "Documento2",
        documentName: "Documento2.pdf",
        size: "2MB",
        status: 200,
        date: "28-12-2023",
      },
      {
        id: 3,
        name: "Documento3",
        documentName: "Documento3.pdf",
        size: "2MB",
        status: 200,
        date: "28-06-2023",
      },
    {
      id: 4,
      name: "Documento4",
      documentName: "Documento4.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 5,
      name: "Documento5",
      documentName: "Documento5.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
    {
      id: 6,
      name: "Documento6",
      documentName: "Documento6.pdf",
      size: "2MB",
      status: 200,
      date: "28-06-2023",
    },
    {
      id: 7,
      name: "Documento7",
      documentName: "Documento7.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 8,
      name: "Documento8",
      documentName: "Documento8.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
    {
      id: 9,
      name: "Documento9",
      documentName: "Documento9.pdf",
      size: "2MB",
      status: 200,
      date: "28-06-2023",
    },
    {
      id: 10,
      name: "Documento10",
      documentName: "Documento10.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 11,
      name: "Documento11",
      documentName: "Documento11.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
    {
      id: 12,
      name: "Documento12",
      documentName: "Documento12.pdf",
      size: "2MB",
      status: 200,
      date: "28-06-2023",
    },
    {
      id: 13,
      name: "Documento13",
      documentName: "Documento13.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 14,
      name: "Documento14",
      documentName: "Documento14.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
    {
      id: 15,
      name: "Documento15",
      documentName: "Documento15.pdf",
      size: "2MB",
      status: 200,
      date: "28-06-2023",
    },
    {
      id: 16,
      name: "Documento16",
      documentName: "Documento16.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 17,
      name: "Documento17",
      documentName: "Documento17.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
    {
      id: 18,
      name: "Documento18",
      documentName: "Documento18.pdf",
      size: "2MB",
      status: 200,
      date: "28-06-2023",
    },
    {
      id: 19,
      name: "Documento19",
      documentName: "Documento19.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2024",
    },
    {
      id: 20,
      name: "Documento20",
      documentName: "Documento20.pdf",
      size: "2MB",
      status: 200,
      date: "28-12-2023",
    },
  ];
  

  const toggleDocument = (tab, document) => {
    setPdfActive(tab);
    setSelectedDocument(document);
  };

  useEffect(() => {
    const addEllipsisIfNeeded = () => {
      const navLinks = document.querySelectorAll(".nav-link");
      navLinks.forEach((navLink) => {
        const isTextOverflowed = navLink.scrollWidth > navLink.clientWidth;
        if (isTextOverflowed) {
          navLink.classList.add("ellipsis");
        }
      });
    };

    addEllipsisIfNeeded();
    window.addEventListener("resize", addEllipsisIfNeeded);
    return () => {
      window.removeEventListener("resize", addEllipsisIfNeeded);
    };
  }, []);

  return (
    <Fragment>
      {loading && (
        <div className="row">
          <div className="col-12 px-2 py-4 text-center">
            <Spinner size="lg" />
            <CardText className={"py-1 fs-5"}>Cargando...</CardText>
          </div>
        </div>
      )}

      {!loading && !expirePage && (
        <div className="row">
          <div className="col-12 px-2 py-1">
            <Card>
              <CardHeader>
                <h2>Facturación Electrónica</h2>
              </CardHeader>
              <CardBody>
                <Row className="">
                  <Col
                    className="pt-2"
                    md={{ size: 7, order: 1 }}
                    xs={{ size: 12, order: 1 }}
                  >
                    <div
                      className="bg-primary text-center mx-auto"
                      style={{
                        width: "80%",
                        paddingTop: 5,
                        paddingBottom: 5,
                        borderRadius: 10,
                        marginBottom: 22
                      }}
                    >
                      <p className="text-white fs-5 m-0">
                        Visualizador de documentos
                      </p>
                    </div>
                    <div>
                      <hr />
                      <span className={"py-2 d-block fs-3 fw-bold text-center"}>
                        {Object.keys(selectedDocument).length > 0? selectedDocument?.documentName.replace('.pdf', '') : "Nombre documento"}
                      </span>
                    </div>

                    <div className="py-50" activeTab={pdfActive}>
                      {selectedDocument &&
                      Object.keys(selectedDocument).length > 0 ? (
                        <>
                          <h1>VISTA PREVIA PDF</h1>
                          {/* <PDFViewer
                                  isActive={pdfActive === index}
                                  //url={`${process.env.REACT_APP_API_URL}/documents/download/${document.id}`}
                                  //token={params.token}
                                  pdfFilePath='./pdf-test/sample.json'
                                  style={{
                                    display: "inline-flex",
                                    height: mobile ? "480px" : "1065px",
                                    width: "100%",
                                  }}
                                /> */}
                          {/*<a href={`data:application/pdf;base64,${document.data}`}
                                                               download={document.name}>
                                                                <small>Descargar</small>
                                                            </a>*/}
                        </>
                      ) : (
                        <div className="row justify-content-center pt-3">
                          <div className="col-12 px-2 py-1 text-center ">
                            <Alert color="success">
                              <div className="alert-body py-3">
                                <h3 className="text-success pt-2">
                                  Seleccione un documento para poder
                                  visualizarlo.
                                </h3>
                              </div>
                            </Alert>
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col
                    className="pt-2"
                    md={{ size: 5, order: 2 }}
                    xs={{ size: 12, order: 2 }}
                  >
                    <Row>
                      <Col
                        md={{ size: 7, order: 0 }}
                        xs={{ size: 6, order: 0 }}
                      >
                        <h3 className={"pb-1"}>Facturas emitidas</h3>
                        <hr />
                      </Col>

                      <Col
                        md={{ size: 5, order: 1 }}
                        xs={{ size: 6, order: 1 }}
                      >
                        <img
                          src={crediq}
                          className={"ps-2 text-end"}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "39px",
                            float: "right",
                          }}
                          alt={"crediq"}
                        />
                      </Col>
                    </Row>

                    <Form>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: 35,
                        }}
                      >
                        <Row>
                          <Col md="6" className="mb-1">
                            <Label className="form-label" for="fromDate">
                              Desde
                            </Label>
                            <Controller
                              id="fromDate"
                              name="fromDate"
                              control={control}
                              render={({ field }) => (
                                <CustomDate {...field} disableDay={false} />
                              )}
                            />
                          </Col>

                          <Col md="6" className={`mb-1 ${isMobile ? 'mt-2' : ''}`}>
                            <Label className="form-label" for="toDate">
                              Hasta
                            </Label>
                            <Controller
                              id="toDate"
                              name="toDate"
                              control={control}
                              render={({ field }) => (
                                <CustomDate {...field} disableDay={false} />
                              )}
                            />
                          </Col>
                        </Row>

                        <Row className="mt-2">
                          <Col className="text-start">
                            <Button
                              type="submit"
                              color="primary"
                              className="me-2"
                              onClick={handleSubmit(onSubmit)}
                            >
                              Buscar
                            </Button>
                          </Col>

                          <Col className="text-start">
                            <Button
                              type="button"
                              color="secondary"
                              onClick={handleReset}
                            >
                              Limpiar
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Form>

                    <Col
                      md={{ size: 12, order: 1 }}
                      xs={{ size: 12, order: 1 }}
                    >
                      <div className={"pt-1"}>
                        <Table className={"my-2"} borderless responsive>
                          <thead>
                            <tr>
                              <th width={"20%"}>Seleccione</th>
                              <th width={"80%"}>Documento</th>
                            </tr>
                          </thead>
                          <tbody>
                            {mockDocuments.length > 0 ? (
                              <DocumentList
                                documents={
                                  filteredDocuments.length > 0 ? filteredDocuments : mockDocuments
                                }
                                onToggleDocument={toggleDocument}
                                checks={checks}
                                onCheckChange={(checked, document) => {
                                  if (checked) {
                                    setChecks((old) => [
                                      ...old,
                                      {
                                        id: document.id,
                                        documentName: document.documentName,
                                        documentSize: document.size,
                                      },
                                    ]);
                                  } else {
                                    setChecks(
                                      checks.filter(
                                        (a) =>
                                          a.documentName !==
                                          document.documentName
                                      )
                                    );
                                  }
                                }}
                              />
                            ) : (
                              <tr>
                                <td colSpan={2}>
                                  <span
                                    className={
                                      "d-block p-3 m-0 m-auto text-center"
                                    }
                                  >
                                    No hay documentos.
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>

                    <Col
                      style={{
                        paddingBottom: "10rem",
                      }}
                      md={{ size: 12, order: 2 }}
                      xs={{ size: 12, order: 2 }}
                    >
                      <hr />
                      <div className="pb-2 text-end float-end">
                        <Button
                          type="button"
                          color="primary"
                          disabled={!checks.length}
                        >
                          Descargar
                        </Button>
                      </div>
                    </Col>

                    <Col
                      md={{ size: 12, order: 2 }}
                      xs={{ size: 12, order: 2 }}
                    >
                      <img
                        src={RubriDoc}
                        style={{
                          height: "40px",
                          position: "absolute",
                          bottom: "25px",
                          right: "25px",
                        }}
                        className={"text-center m-auto"}
                        alt={"rubridoc"}
                      />
                    </Col>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default InvoicesViewer;
